import Vue from "vue";

interface IInput {
	validate():boolean;
	$watch(eventName:string, handler:Function):any;
}

export const FormLike = Vue.extend({
	data() {
		return {
			inputElements: [] as IInput[],
			isValid: true,
			enterSubmits: true,
			validators: [] as (()=>boolean)[],
		};
	},
	methods: {
		registerInput(el:IInput) {
			this.inputElements.push(el);
			el.$watch("value", this.validate);
		},
		deregisterInput(el:IInput) {
			let index = this.inputElements.indexOf(el);
			if (index != -1) {
				this.inputElements.splice(index, 1);
			}
		},
		validate() {
			this.isValid = true;
			for (let el of this.inputElements) {
				if (!el.validate()) {
					this.isValid = false;
				}
			}
			for (let validator of this.validators){
				if (!validator()){
					this.isValid = false;
				}
			}
			this.extendValidate();
			this.$emit("valid", this.isValid);
		},
		extendValidate(){

		},
		onKeyUp(e:KeyboardEvent) {
			let isChild = false;
			let el = document.activeElement;
			if (!el) return;

			while(el != null) {
				if (el.hasAttribute("w-formlike")){
					if (el == this.$el){
						isChild = true;
					}
					break;
				}
				el = el.parentElement;
			};

			if (!isChild) return;

			if (e.key == "Enter" && this.enterSubmits) {
				e.stopPropagation();
				e.preventDefault();
				this.submit();
			}
		},
		submit() {

		}
	},
	created() {
		this.$emit("valid", true);
	},
	mounted(){
		this.$el.setAttribute("w-formlike", "true");
		window.addEventListener("keyup", this.onKeyUp);
	},
	destroyed() {
		window.removeEventListener("keyup", this.onKeyUp);
	}
});